module.exports = __webpack_public_path__ + "media/img/pages/companies/denner-b255047d7b9a3651826d3ad75c315f63.png";